import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import Grid from "@saleor/components/Grid";
import RadioGroupField from "@saleor/components/RadioGroupField";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import {
  DiscountDeliveryTypeEnum,
  VoucherClassificationEnum,
  VoucherDiscountType,
  VoucherTypeEnum
} from "../../../types/globalTypes";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";

interface VoucherTypesProps {
  data: VoucherDetailsPageFormData;
  errors: DiscountErrorFragment[];
  disabled: boolean;

  onChange: (event: ChangeEvent<any>) => void;
}

const VoucherTypes = ({
  data,
  disabled,
  errors,
  onChange
}: VoucherTypesProps) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["discountType"], errors);

  const handleOnChange = e => {
    let newArray = data.deliveryType;
    switch (e.target.value) {
      case VoucherDiscountType.SHIPPING:
        newArray = newArray.filter(
          item => item !== DiscountDeliveryTypeEnum.IN_STORE
        );
        break;
    }
    const newEvent = {
      target: { name: "deliveryType", value: newArray }
    };
    onChange(newEvent);
  };

  const voucherTypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Fixed Amount",
        description: "voucher discount type"
      }),
      value: VoucherDiscountType.FIXED
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Percentage",
        description: "voucher discount type"
      }),
      value: VoucherDiscountType.PERCENTAGE
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      label: intl.formatMessage({
        defaultMessage: "Free Shipping",
        description: "voucher discount type"
      }),
      value: VoucherDiscountType.SHIPPING
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Capped and Percentage",
        description: "voucher discount type"
      }),
      value: VoucherDiscountType.PERCENTAGE_AND_CAPPED
    },
    {
      disabled:
        disabled ||
        data.verticalType === VoucherClassificationEnum.SM_FULFILLED,
      label: intl.formatMessage({
        defaultMessage: "E-Voucher",
        description: "voucher discount type"
      }),
      value: VoucherDiscountType.E_VOUCHER
    }
  ];

  const [valueTypes, setValueTypes] = React.useState();

  const defaultValueTypes = data?.maxDiscountValue
    ? VoucherDiscountType.PERCENTAGE_AND_CAPPED
    : data?.type === VoucherTypeEnum.SHIPPING
    ? VoucherTypeEnum.SHIPPING
    : data?.type === VoucherTypeEnum.E_VOUCHER
    ? VoucherTypeEnum.E_VOUCHER
    : data.discountType;

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Voucher Type",
          description: "header"
        })}
      />
      <CardContent>
        <Grid variant="uniform">
          <RadioGroupField
            choices={voucherTypeChoices}
            disabled={disabled}
            error={!!formErrors.discountType}
            hint={getDiscountErrorMessage(formErrors.discountType, intl)}
            name={"discountType" as keyof VoucherDetailsPageFormData}
            value={valueTypes || defaultValueTypes}
            // onChange={onChange}
            onChange={event => {
              onChange(event);
              handleOnChange(event);
              setValueTypes(event.target.value);
            }}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};
export default VoucherTypes;
